'use client';

import { useSettings } from '@capsicum/common';
import { FingerprintJSPro, FpjsProvider } from '@fingerprintjs/fingerprintjs-pro-react';
import { type PropsWithChildren } from 'react';

export const FingerprintJSProvider = ({ children }: PropsWithChildren) => {
	const { areSettingsLoading, settings } = useSettings();

	if (areSettingsLoading) {
		return null;
	}

	const {
		fingerprintJSConfig: {
			apiKey,
			enabled,
			endpoint,
			integrationInfo,
			region,
			remoteControlDetection,
			scriptUrlPattern
		}
	} = settings;

	if (!enabled || !apiKey) {
		return children;
	}

	return (
		<FpjsProvider
			loadOptions={{
				apiKey,
				endpoint: [endpoint ?? FingerprintJSPro.defaultEndpoint, FingerprintJSPro.defaultEndpoint],
				integrationInfo,
				region,
				remoteControlDetection,
				scriptUrlPattern: [
					scriptUrlPattern ?? FingerprintJSPro.defaultScriptUrlPattern,
					FingerprintJSPro.defaultScriptUrlPattern
				]
			}}
		>
			{children}
		</FpjsProvider>
	);
};
